<template>
  <div class="agreement">
    <!-- 电影背景装饰 -->
    <div class="cinema-background">
      <div class="film-strip top-strip"></div>
      <div class="spotlight spotlight-1"></div>
      <div class="spotlight spotlight-2"></div>
    </div>

    <!-- 页面头部 -->
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">用户协议</h1>
        <p class="page-subtitle">请仔细阅读以下协议内容</p>
        <div class="page-decoration"></div>
      </div>
    </div>

    <div class="container">
      <!-- 协议内容卡片 -->
      <div class="agreement-card">
        <!-- 协议头部 -->
        <div class="agreement-header">
          <div class="header-icon"></div>
          <h2>北京首都华融影院有限责任公司用户服务协议</h2>
          <p class="update-time">最后更新日期：2025年11月</p>
        </div>

        <!-- 协议内容 -->
        <div class="agreement-content">
          <!-- 章节1 -->
          <div class="agreement-section">
            <h3 class="section-title">
              <span class="section-number">01</span>
              总则
            </h3>
            <div class="section-content">
              <p>欢迎您使用北京首都华融影院有限责任公司提供的各项服务！</p>
              <p>本协议是您与北京首都华融影院有限责任公司之间就使用本网站服务所订立的协议。请您仔细阅读本协议，如果您不同意本协议的任意内容，您应当立即停止使用本服务。</p>
            </div>
          </div>

          <!-- 章节2 -->
          <div class="agreement-section">
            <h3 class="section-title">
              <span class="section-number">02</span>
              服务内容
            </h3>
            <div class="section-content">
              <p>1. 北京首都华融影院有限责任公司通过互联网为您提供以下服务：</p>
              <ul class="content-list">
                <li>电影资讯浏览服务</li>
                <li>在线影票预订服务</li>
                <li>会员积分管理服务</li>
                <li>个性化推荐服务</li>
                <li>其他相关增值服务</li>
              </ul>
              <p>2. 您理解并同意，本服务仅按现有技术和条件提供，我们会尽力维护服务的稳定性，但对服务中出现的信息删除、存储失败等不承担责任。</p>
            </div>
          </div>

          <!-- 章节3 -->
          <div class="agreement-section">
            <h3 class="section-title">
              <span class="section-number">03</span>
              用户账号
            </h3>
            <div class="section-content">
              <p>1. 您在使用本服务前需要注册一个北京首都华融影院有限责任公司账号。账号注册成功后，您有权使用您确认的用户名和密码登录。</p>
              <p>2. 您应妥善保管您的账号及密码，并正确、安全地使用您的账号及密码。您同意在任何情况下不向他人透露账号及密码。</p>
              <p>3. 您理解并同意，为保障您和本平台的利益，本平台有权核查您提交的相关身份信息，并有权根据核查结果决定是否为您提供服务。</p>
            </div>
          </div>

          <!-- 章节4 -->
          <div class="agreement-section">
            <h3 class="section-title">
              <span class="section-number">04</span>
              用户行为规范
            </h3>
            <div class="section-content">
              <p>您在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，包括但不限于：</p>
              <ul class="content-list">
                <li>发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容</li>
                <li>发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容</li>
                <li>虚构事实、隐瞒真相以误导、欺骗他人</li>
                <li>发表、传送、传播广告信息及垃圾信息</li>
                <li>从事其他违反法律法规、政策及公序良俗、社会公德等的行为</li>
              </ul>
            </div>
          </div>

          <!-- 章节5 -->
          <div class="agreement-section">
            <h3 class="section-title">
              <span class="section-number">05</span>
              知识产权
            </h3>
            <div class="section-content">
              <p>1. 本服务中包含的任何文字、图表、音频、视频和/软件等均受著作权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。</p>
              <p>2. 本平台为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，您不得对该软件进行反向工程、反向编译或反汇编。</p>
            </div>
          </div>

          <!-- 章节6 -->
          <div class="agreement-section">
            <h3 class="section-title">
              <span class="section-number">06</span>
              隐私保护
            </h3>
            <div class="section-content">
              <p>1. 保护用户隐私是我们的基本政策，我们保证不对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在本平台的非公开内容，但下列情况除外：</p>
              <ul class="content-list">
                <li>事先获得用户的明确授权</li>
                <li>根据有关的法律法规要求</li>
                <li>按照相关政府主管部门的要求</li>
                <li>为维护社会公众的利益</li>
                <li>为维护本平台的合法权益</li>
              </ul>
              <p>2. 在不透露单个用户隐私资料的前提下，本平台有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>
            </div>
          </div>

          <!-- 章节7 -->
          <div class="agreement-section">
            <h3 class="section-title">
              <span class="section-number">07</span>
              免责声明
            </h3>
            <div class="section-content">
              <p>1. 对于因不可抗力或本平台不能控制的原因造成的网络服务中断或其它缺陷，本平台不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</p>
              <p>2. 本平台不对用户所发布信息的删除或储存失败负责。本平台有权判断用户的行为是否符合本平台服务条款的规定，如果本平台认为用户违背了服务条款的规定，本平台有权删除用户发布或发送的信息，乃至中断或终止向其提供网络服务。</p>
            </div>
          </div>

          <!-- 章节8 -->
          <div class="agreement-section">
            <h3 class="section-title">
              <span class="section-number">08</span>
              协议修改
            </h3>
            <div class="section-content">
              <p>1. 本平台有权随时修改本协议的任何条款，一旦本协议的内容发生变动，本平台将会通过网站公布等方式向您提示修改内容。</p>
              <p>2. 如果您不同意本平台对本协议相关条款所做的修改，您有权停止使用网络服务。如果您继续使用网络服务，则视为您接受本平台对本协议相关条款所做的修改。</p>
            </div>
          </div>

          <!-- 协议确认 -->
          <div class="agreement-confirm">
            <div class="confirm-content">
              <p>请您仔细阅读以上协议内容，当您点击"同意并继续"按钮时，即表示您已阅读、理解并同意接受本协议的全部内容。</p>
              <div class="confirm-actions">
                <button class="confirm-btn" @click="agreeAgreement">
                  <span class="btn-text">同意并继续</span>
                  <div class="btn-shine"></div>
                </button>
                <button class="cancel-btn" @click="goBack">
                  返回
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部装饰 -->
    <div class="bottom-decoration">
      <div class="film-strip bottom-strip"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Agreement",
  methods: {
    agreeAgreement() {
      // 同意协议后的操作，可以存储状态或直接返回
      this.$router.go(-1); // 返回上一页
    },
    goBack() {
      this.$router.go(-1); // 返回上一页
    }
  },
  mounted() {
    document.title = "首都电影院";
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.agreement {
  margin-top: 100px;
  min-height: calc(100vh - 100px);
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #f8f9fa 100%);
  position: relative;
  overflow: hidden;

  // 电影背景装饰
  .cinema-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .film-strip {
      position: absolute;
      left: 0;
      width: 100%;
      height: 20px;
      background: repeating-linear-gradient(
        90deg,
        #000 0px,
        #000 10px,
        #ff6b6b 10px,
        #ff6b6b 20px,
        #000 20px,
        #000 30px
      );
      opacity: 0.1;

      &.top-strip {
        top: 0;
      }
    }

    .spotlight {
      position: absolute;
      width: 300px;
      height: 300px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(255, 107, 107, 0.05) 0%, transparent 70%);
      filter: blur(20px);

      &.spotlight-1 {
        top: 10%;
        left: 10%;
      }

      &.spotlight-2 {
        top: 60%;
        right: 15%;
      }
    }
  }

  // 页面头部
  .page-header {
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
    color: white;
    padding: 60px 0 40px;
    margin-bottom: 40px;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="film" width="10" height="10" patternUnits="userSpaceOnUse"><rect width="10" height="10" fill="none"/><circle cx="2" cy="2" r="1" fill="%23ff6b6b" opacity="0.3"/><circle cx="8" cy="8" r="1" fill="%23ff6b6b" opacity="0.3"/></pattern></defs><rect width="100" height="100" fill="url(%23film)"/></svg>');
      opacity: 0.1;
    }

    .container {
      position: relative;
      z-index: 1;
      text-align: center;
    }

    .page-title {
      font-size: 42px;
      font-weight: bold;
      margin-bottom: 15px;
      color: #ff6b6b;
      text-shadow: 0 2px 10px rgba(255, 107, 107, 0.3);
    }

    .page-subtitle {
      font-size: 18px;
      opacity: 0.9;
      margin-bottom: 20px;
      letter-spacing: 1px;
    }

    .page-decoration {
      height: 4px;
      background: linear-gradient(90deg, transparent, #ff6b6b, transparent);
      border-radius: 2px;
      margin: 0 auto;
      width: 100px;
    }
  }

  .container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
  }

  // 协议内容卡片
  .agreement-card {
    background: white;
    border-radius: 20px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 107, 107, 0.2);
    margin-bottom: 60px;
    overflow: hidden;

    // 协议头部
    .agreement-header {
      background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
      color: white;
      padding: 40px;
      text-align: center;
      position: relative;

      .header-icon {
        width: 60px;
        height: 60px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        margin: 0 auto 20px;
        opacity: 0.9;
      }

      h2 {
        font-size: 32px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .update-time {
        font-size: 14px;
        opacity: 0.8;
        margin: 0;
      }
    }

    // 协议内容
    .agreement-content {
      padding: 40px;
      max-height: 70vh;
      overflow-y: auto;

      // 自定义滚动条
      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb {
        background: #ff6b6b;
        border-radius: 3px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #ff8e8e;
      }

      // 协议章节
      .agreement-section {
        margin-bottom: 40px;

        .section-title {
          font-size: 22px;
          font-weight: bold;
          color: #1a1a1a;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 15px;
          padding-bottom: 10px;
          border-bottom: 2px solid rgba(255, 107, 107, 0.2);

          .section-number {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
            color: white;
            border-radius: 50%;
            font-size: 16px;
            font-weight: bold;
          }
        }

        .section-content {
          p {
            font-size: 15px;
            line-height: 1.8;
            color: #555;
            margin-bottom: 15px;
            text-align: justify;
          }

          .content-list {
            margin: 15px 0;
            padding-left: 20px;

            li {
              font-size: 15px;
              line-height: 1.8;
              color: #555;
              margin-bottom: 8px;
              position: relative;

              &::before {
                content: '';
                position: absolute;
                left: -15px;
                top: 10px;
                width: 6px;
                height: 6px;
                background: #ff6b6b;
                border-radius: 50%;
              }
            }
          }
        }
      }

      // 协议确认
      .agreement-confirm {
        margin-top: 50px;
        padding-top: 30px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);

        .confirm-content {
          text-align: center;

          p {
            font-size: 16px;
            line-height: 1.6;
            color: #666;
            margin-bottom: 30px;
            font-weight: 500;
          }

          .confirm-actions {
            display: flex;
            gap: 20px;
            justify-content: center;

            .confirm-btn {
              background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
              color: white;
              border: none;
              padding: 15px 40px;
              border-radius: 25px;
              font-size: 16px;
              font-weight: bold;
              cursor: pointer;
              transition: all 0.3s ease;
              position: relative;
              overflow: hidden;
              box-shadow: 0 8px 25px rgba(255, 107, 107, 0.3);

              .btn-text {
                position: relative;
                z-index: 2;
              }

              .btn-shine {
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
                transition: left 0.5s ease;
              }

              &:hover {
                transform: translateY(-3px);
                box-shadow: 0 12px 30px rgba(255, 107, 107, 0.4);

                .btn-shine {
                  left: 100%;
                }
              }

              &:active {
                transform: translateY(-1px);
              }
            }

            .cancel-btn {
              background: transparent;
              color: #666;
              border: 2px solid #ddd;
              padding: 15px 40px;
              border-radius: 25px;
              font-size: 16px;
              font-weight: bold;
              cursor: pointer;
              transition: all 0.3s ease;

              &:hover {
                border-color: #ff6b6b;
                color: #ff6b6b;
                transform: translateY(-2px);
              }
            }
          }
        }
      }
    }
  }

  // 底部装饰
  .bottom-decoration {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;

    .film-strip {
      height: 20px;
      background: repeating-linear-gradient(
        90deg,
        #000 0px,
        #000 10px,
        #ff6b6b 10px,
        #ff6b6b 20px,
        #000 20px,
        #000 30px
      );
      opacity: 0.3;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .agreement {
    .container {
      padding: 0 15px;
    }

    .agreement-card {
      .agreement-header {
        padding: 30px 20px;

        h2 {
          font-size: 24px;
        }
      }

      .agreement-content {
        padding: 30px 20px;

        .agreement-section {
          .section-title {
            font-size: 18px;
          }
        }

        .agreement-confirm {
          .confirm-actions {
            flex-direction: column;
            align-items: center;

            .confirm-btn, .cancel-btn {
              width: 100%;
              max-width: 300px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .agreement {
    .page-header {
      padding: 40px 0 30px;

      .page-title {
        font-size: 32px;
      }

      .page-subtitle {
        font-size: 16px;
      }
    }

    .agreement-card {
      .agreement-content {
        .agreement-section {
          .section-title {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }
        }
      }
    }
  }
}
</style>